"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const borderRadius = {
    outer: 16,
    inner: 8,
    mini: 4,
};
exports.default = borderRadius;
//# sourceMappingURL=border-radius.js.map